/**
 * KWYKEDIT brand + product configuration.
 *
 * Central place for the visible product name, the AI-creation feature flag,
 * pricing, and the supported-browser note. UI copy should reference APP_NAME
 * instead of hardcoding a product name so a rebrand stays a one-line change.
 *
 * NOTE: `LICENSE` (MIT attribution to the upstream FreeCut project) must stay
 * untouched — this config only affects visible UI strings.
 */

/** Visible product name rendered in headers, titles, and docs. */
export const APP_NAME = 'KWYKEDIT'

/**
 * Gates AI *creation* UI (TTS, music generation, transcription dialogs).
 * Default false: creation entry points render a "Pro editing only" placeholder
 * or nothing, while AI *service* files stay in the repo untouched.
 * Analysis paths (histogram scene detection, CLIP/semantic search) are NOT
 * gated by this flag and stay enabled.
 */
export const ENABLE_AI_CREATION = false

/** Public monthly price in USD, surfaced in Pro upsell placeholders. */
export const PRICE_MONTHLY_USD = 3

/**
 * Gates the PWA "Install KWYKEDIT" prompt. Default false: kwykedit.com is the
 * only portal — no desktop/home-screen install offers. The manifest, service
 * worker, and prompt component stay in the repo untouched; only the UI is
 * suppressed.
 */
export const ENABLE_PWA_INSTALL = false

/** Short browser-support note shown on screens that need it (workspace gate). */
export const SUPPORTED_BROWSERS =
  'KWYKEDIT works best in a recent Chromium browser (Chrome, Edge, Brave, or Arc 113+) with hardware acceleration enabled.'
